var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { makeRequestOptionsWithBody } from "./request/ApiRequest";
import { DEFAULT_BASE_API_URL, DEFAULT_USE_CASE_HEADER_VALUE, ENDPOINTS } from "./request/meta";
import BaseClient from "./BaseClient";
var DEFAULT_FETCH_RETRY_DELAY_MILLIS = 1000;
var LowLevelClient = /** @class */ (function (_super) {
    __extends(LowLevelClient, _super);
    function LowLevelClient(fetch, apiToken, _a, delayFunc) {
        var _b = _a === void 0 ? {} : _a, _c = _b.useCaseHeader, useCaseHeader = _c === void 0 ? DEFAULT_USE_CASE_HEADER_VALUE : _c;
        if (delayFunc === void 0) { delayFunc = delay; }
        var _this = _super.call(this, apiToken, { useCaseHeader: useCaseHeader }) || this;
        _this.fetch = fetch;
        _this.delayFunc = delayFunc;
        return _this;
    }
    LowLevelClient.prototype.fetchWithAuth = function (resource, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        this.preFlightProcessOptions(options);
        return getFetchPromise(this.fetch, resource, options)
            .catch(function (error) {
            // Only retry on network errors or server errors (5xx), not authentication errors (4xx)
            if (error && error.status && error.status >= 400 && error.status < 500) {
                // Client errors (4xx) - don't retry, preserve the error
                throw error;
            }
            // If we fail on the first fetch with network/server error, try one more fetch
            return _this.delayFunc(DEFAULT_FETCH_RETRY_DELAY_MILLIS)
                .then(function () {
                return getFetchPromise(_this.fetch, resource, options);
            });
        });
    };
    return LowLevelClient;
}(BaseClient));
function delay(timeMillis) {
    return new Promise(function (resolve) {
        setTimeout(resolve, timeMillis);
    });
}
function getFetchPromise(fetch, resource, options) {
    return new Promise(function (resolve, reject) {
        fetch(resource, options)
            .then(function (resp) {
            if (resp.ok) {
                resolve(resp);
            }
            else {
                reject(resp);
            }
        })
            .catch(reject);
    });
}
var Client = /** @class */ (function () {
    function Client(fetch, apiToken, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.baseUrl, baseUrl = _c === void 0 ? DEFAULT_BASE_API_URL : _c, _d = _b.useCaseHeader, useCaseHeader = _d === void 0 ? DEFAULT_USE_CASE_HEADER_VALUE : _d;
        this.baseUrl = baseUrl;
        this.lowLevelClient = new LowLevelClient(fetch, apiToken, {
            useCaseHeader: useCaseHeader,
        });
    }
    Client.prototype.fetchCustomerId = function () {
        var _this = this;
        if (this.customerId !== undefined) {
            return Promise.resolve(this.customerId);
        }
        return this.lowLevelClient
            .fetchWithAuth(ENDPOINTS.CLIENT(this.baseUrl))
            .then(function (response) { return response.json(); })
            .then(function (json) {
            var customerId = json.data[0].customer_id;
            _this.customerId = customerId;
            return customerId;
        });
    };
    Client.prototype.fetchCustomerProfiles = function () {
        var _this = this;
        return this.fetchCustomerId().then(function (customerId) {
            return _this.lowLevelClient.fetchWithAuth(ENDPOINTS.CUSTOMER_PROFILES(_this.baseUrl, customerId));
        });
    };
    Client.prototype.fetchCustomerTags = function () {
        var _this = this;
        return this.fetchCustomerId().then(function (customerId) {
            return _this.lowLevelClient.fetchWithAuth(ENDPOINTS.TAGS(_this.baseUrl, customerId));
        });
    };
    Client.prototype.fetchCustomerGroups = function () {
        var _this = this;
        return this.fetchCustomerId().then(function (customerId) {
            return _this.lowLevelClient.fetchWithAuth(ENDPOINTS.GROUPS(_this.baseUrl, customerId));
        });
    };
    Client.prototype.fetchAnalyticsProfileMetrics = function (body) {
        var _this = this;
        return this.fetchCustomerId().then(function (customerId) {
            return _this.lowLevelClient.fetchWithAuth(ENDPOINTS.ANALYTICS_PROFILE_METRICS(_this.baseUrl, customerId), makeRequestOptionsWithBody(body));
        });
    };
    Client.prototype.fetchAnalyticsPosts = function (body) {
        var _this = this;
        return this.fetchCustomerId().then(function (customerId) {
            return _this.lowLevelClient.fetchWithAuth(ENDPOINTS.ANALYTICS_POSTS(_this.baseUrl, customerId), makeRequestOptionsWithBody(body));
        });
    };
    return Client;
}());
export default Client;
export { LowLevelClient };
